import { CoreAdminContext } from 'ra-core'
import { createBrowserHistory } from 'history'
import { HelmetProvider } from 'react-helmet-async';
import polyglotI18nProvider from 'ra-i18n-polyglot'
import React from 'react';
import ReactDOM from 'react-dom';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';

import './index.css';
import { SettingsProvider } from './contexts/SettingsContext';
import allOdSagas from './sideEffects'
import App from './App';
import authProvider from './authProvider/authProvider'
import dataProvider from "./dataProvider/rest"
import englishMessages from './i18n/en'
import odReducers from './reducers'
import reportWebVitals from './reportWebVitals';


const i18nProvider = polyglotI18nProvider(locale => {
  if (locale === 'whatever') {
    // return import('./i18n/whatever').then(messages => messages.default)
  }
  return englishMessages
})

const history = createBrowserHistory();

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <SettingsProvider>
          <CoreAdminContext
            authProvider={authProvider}
            dataProvider={dataProvider}
            i18nProvider={i18nProvider}
            history={history}
            customReducers={{od:odReducers}}
            customSagas={[allOdSagas(authProvider)]}
            //initialState={state}
          >
            <App />
          </CoreAdminContext>
        </SettingsProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
